import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _routeData, _uuid, _pendingStore, _HistoryStore_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service, { service } from "@ember/service";
import { TrackedMap } from "@ember-compat/tracked-built-ins";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { isTesting } from "discourse-common/config/environment";
import { bind } from "discourse-common/utils/decorators";
const HISTORY_SIZE = 100;
const HISTORIC_KEY = Symbol("historic");
const HANDLED_TRANSITIONS = new WeakSet();

/**
 * This service provides a key-value store which can store per-route information.
 * When navigating 'back' via browser controls, the service will restore the data
 * for the appropriate route.
 */
let HistoryStore = disableImplicitInjections(_class = (_class2 = (_routeData = /*#__PURE__*/new WeakMap(), _uuid = /*#__PURE__*/new WeakMap(), _pendingStore = /*#__PURE__*/new WeakMap(), _HistoryStore_brand = /*#__PURE__*/new WeakSet(), class HistoryStore extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _HistoryStore_brand);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _classPrivateFieldInitSpec(this, _routeData, new Map());
    _classPrivateFieldInitSpec(this, _uuid, void 0);
    _classPrivateFieldInitSpec(this, _pendingStore, void 0);
  }
  /**
   * Identify if the current route was accessed via the browser back/forward buttons
   * @returns {boolean}
   */
  get isPoppedState() {
    return !!this.get(HISTORIC_KEY);
  }

  /**
   * Fetch a value from the current route's key/value store
   */
  get(key) {
    return _classPrivateGetter(_HistoryStore_brand, this, _get_currentStore).get(key);
  }

  /**
   * Set a value in the current route's key/value store. Will persist for the lifetime
   * of the route, and will be restored if the user navigates 'back' to the route.
   */
  set(key, value) {
    return _classPrivateGetter(_HistoryStore_brand, this, _get_currentStore).set(key, value);
  }

  /**
   * Delete a value from the current route's key/value store
   */
  delete(key) {
    return _classPrivateGetter(_HistoryStore_brand, this, _get_currentStore).delete(key);
  }
  /**
   * Called by the Application route when its willResolveModel hook
   * is triggered by the ember router. Unfortunately this hook is
   * not available as an event on the router service.
   */
  willResolveModel(transition) {
    if (HANDLED_TRANSITIONS.has(transition)) {
      return;
    }
    HANDLED_TRANSITIONS.add(transition);
    if (false /* DEBUG */ && isTesting()) {
      // Can't use window.history in tests
      _classPrivateFieldSet(_pendingStore, this, new TrackedMap());
      return;
    }
    this.set(HISTORIC_KEY, true);
    let pendingStoreForThisTransition;
    if (_classPrivateFieldGet(_uuid, this) === window.history.state?.uuid) {
      // A normal ember transition. The history uuid will only change **after** models are resolved.
      // To allow routes to store data for the upcoming uuid, we set up a temporary data store
      // and then persist it if/when the transition succeeds.
      pendingStoreForThisTransition = new TrackedMap();
    } else {
      // A transition initiated by the browser back/forward buttons. We might already have some stored
      // data for this route. If so, take a copy of it and use that as the pending store. As with normal transitions,
      // it'll be persisted if/when the transition succeeds.
      pendingStoreForThisTransition = new TrackedMap(_assertClassBrand(_HistoryStore_brand, this, _dataFor).call(this, window.history.state?.uuid)?.entries());
    }
    _classPrivateFieldSet(_pendingStore, this, pendingStoreForThisTransition);
    transition.then(() => {
      _classPrivateFieldSet(_uuid, this, window.history.state?.uuid);
      _classPrivateFieldGet(_routeData, this).set(_classPrivateFieldGet(_uuid, this), _classPrivateFieldGet(_pendingStore, this));
      _assertClassBrand(_HistoryStore_brand, this, _pruneOldData).call(this);
    }).finally(() => {
      if (pendingStoreForThisTransition === _classPrivateFieldGet(_pendingStore, this)) {
        _classPrivateFieldSet(_pendingStore, this, null);
      }
    });
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "willResolveModel", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "willResolveModel"), _class2.prototype)), _class2)) || _class;
function _get_currentStore(_this) {
  if (_classPrivateFieldGet(_pendingStore, _this)) {
    return _classPrivateFieldGet(_pendingStore, _this);
  }
  return _assertClassBrand(_HistoryStore_brand, _this, _dataFor).call(_this, _classPrivateFieldGet(_uuid, _this));
}
function _pruneOldData() {
  while (_classPrivateFieldGet(_routeData, this).size > HISTORY_SIZE) {
    // JS Map guarantees keys will be returned in insertion order
    const oldestUUID = _classPrivateFieldGet(_routeData, this).keys().next().value;
    _classPrivateFieldGet(_routeData, this).delete(oldestUUID);
  }
}
function _dataFor(uuid) {
  let data = _classPrivateFieldGet(_routeData, this).get(uuid);
  if (data) {
    return data;
  }
  data = new TrackedMap();
  _classPrivateFieldGet(_routeData, this).set(uuid, data);
  _assertClassBrand(_HistoryStore_brand, this, _pruneOldData).call(this);
  return data;
}
export { HistoryStore as default };